import {useContext} from 'react';
import assert from 'assert-ts';
import {ScheduleDataContext} from './ScheduleDataContext';
import {ScheduleDataContextType} from '../types';

export const useScheduleDataContext = (): ScheduleDataContextType => {
  const context = useContext(ScheduleDataContext);
  return assert(
    context,
    'ScheduleViewModel Context could not be found. Did you wrap your container in a ScheduleViewModel provider?',
  );
};
